import * as React from 'react'
import cx from 'classnames'
import { ControlStatus } from '../ControlStatus'
import { NEVER, Observable } from 'rxjs'
import AutosizeTextarea from 'react-textarea-autosize'
import { mergeRefs } from 'utils/react-util'
import { useFocusTracking, useObservableFocus } from 'hooks/focus-hooks'
import styles from './TextArea.sass'

export interface TextAreaProps
  extends React.ComponentPropsWithRef<typeof AutosizeTextarea> {
  status?: ControlStatus
  value?: string
  rows?: number
  autoSize?: boolean
  focus$?: Observable<unknown>
  isNotValid?: boolean
}

export default React.forwardRef(function TextAreaInput(
  {
    className,
    value,
    onChange,
    rows,
    autoSize,
    status = 'default',
    focus$ = NEVER,
    onFocus,
    onBlur,
    isNotValid,
    ...props
  }: TextAreaProps,
  ref: React.Ref<HTMLTextAreaElement>,
) {
  const Element = autoSize ? AutosizeTextarea : 'textarea'
  const inputRef = React.useRef<HTMLTextAreaElement | null>(null)
  useObservableFocus(focus$, inputRef)
  const [focusProps, focused] = useFocusTracking({ onFocus, onBlur })
  return (
    <div
      className={cx(
        styles.input,
        styles[status],
        focused && styles.focused,
        props.disabled && styles.disabled,
        isNotValid && styles.isNotValid,
        className,
      )}
    >
      <Element
        ref={mergeRefs([ref, inputRef])}
        className={cx(styles.inner)}
        value={value}
        onChange={onChange}
        rows={rows || 5}
        {...props}
        {...focusProps}
      />
    </div>
  )
})
